<template>
  <div
    v-if="partner.analyses.length"
    data-qa="partner_analyses_list"
    class="partner-card-border overflow-hidden"
  >
    <div
      :data-partner-id="partner.id"
      :data-partner-name="partner.name"
      :class="isMobile ? 'pa-4' : 'pa-6'"
    >
      <div
        class="d-flex"
        :class="{ 'flex-column': isMobile }"
      >
        <v-img
          max-width="240px"
          min-width="240px"
          max-height="80px"
          min-height="80px"
          :src="partner.logo"
          :alt="`Логотип ${partner.name}`"
          class="mb-6"
          :class="{ 'mx-auto': isMobile, ' flex-grow-1 mr-6': !isMobile }"
          contain
        />
        <div class="d-flex flex-column flex-grow-2 w-100">
          <PrgButton
            v-if="!isMobile"
            class="mb-6"
            :button-attrs="{}"
            :url="`/${town.translit}/analyses/${partner.slug}`"
          >
            <span class="primary--text text-h5">
              Лаборатория «{{ partner.name }}»
            </span>
          </PrgButton>

          <AnalysesList
            show-cart-button
            :partner="localPartner"
            :disable-cart-button="isAnalysisLoading"
            @click:add-to-cart="(analysis) => handleAddAnalysisToCart(localPartner, analysis)"
          />

          <PrgButton
            data-qa="partner-analyses-button-all"
            :button-attrs="{ class: 'primary--text mx-auto bg-primary py-2 px-4 rounded-sm' }"
            class="mx-auto"
            :url="`/${town.translit}/analyses/${partner.slug}`"
          >
            <span class="text-button">
              Показать ещё
            </span>
          </PrgButton>
        </div>
      </div>
    </div>
    <DiscountBanner
      v-if="useBanner"
      :discount="partner.discount"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import AnalysesList from 'www/vue_components/common/Analyses/components/AnalysesList/AnalysesList.vue'
import DiscountBanner from 'www/vue_components/common/Analyses/pages/AnalysesListPage/components/DiscountBanner/DiscountBanner.vue'
import { Partner } from 'www/vue_components/common/Analyses/types'
import PrgButton from 'www/vue_components/common/core/PrgButton/PrgButton.vue'
import useCommonAnalysesStore from 'www/vue_components/common/Analyses/stores/useCommonStore'
import { useCartActions } from 'www/vue_components/common/Analyses/composables/useCartActions'

const props = withDefaults(defineProps<{
  partner: Partner
  useBanner: boolean
}>(), {
  useBanner: false,
})

const isMobile = window.MOBILE_VERSION
const { town } = useCommonAnalysesStore()

const isAnalysisLoading = ref(false)
const isRequestDone = ref(false)

// Если передавать напрямую проп, то иконка корзины не изменяется реактивно
const localPartner = ref(props.partner)

const {
  handleAddAnalysisToCart,
} = useCartActions({
  isAnalysisLoading,
  isRequestDone,
})
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.partner-card-border {
  border: 1px solid $ui-kit-primary;
  border-radius: $border-radius-lg;
}
</style>
